import './kenuikitchen/style';
import FormStructure from './kenuikitchen/form_structure';

export default FormStructure;